import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../index.js";

export default class PageHome
{
    constructor()
    {
        this.getLatestProjectList();
        this.getTopProjectList();
        this.getRandomOps();
    }

    loadActivityFeed(targetElement)
    {
        const apiUrl = web.tabs.addPagination("activityfeed/myfeed", 14);
        api.get(apiUrl, (result) =>
        {
            const data = result.data;
            const entries = data.entries;
            let feedHtml = "";
            let lastUsername = "";
            let usernameCount = 0;

            if (entries.length > 0)
            {
                for (let i = 0; i < entries.length; i++)
                {
                    const entry = entries[i];
                    if (entry.displayActions && entry.displayActions.length > 3)
                    {
                        const allActions = entry.displayActions;
                        const buttons = allActions.slice(0, 3);
                        const menuItems = allActions.slice(3);
                        entry.displayActions = buttons;
                        entry.menuItems = menuItems;
                    }

                    const diffUsername = lastUsername != entry.initiator.username;
                    if (diffUsername)
                    {
                        usernameCount = 0;
                        lastUsername = entry.initiator.username;
                    }
                    else
                    {
                        const maxItemsSameUser = 3;
                        usernameCount++;
                        if (usernameCount == maxItemsSameUser) feedHtml += "<div class=\"cute-1-phone hide-tablet hide-phone left\"></div><a href=\"/myactivityfeed\">even more...</a>";
                        if (usernameCount >= maxItemsSameUser) continue;
                    }

                    entry.thumbFormat = "projectThumb";
                    if (["TeamInvite", "Membership"].includes(entry.topic)) entry.thumbFormat = "team-container";
                    const vars = {
                        "entry": entry,
                        "diffUsername": diffUsername,
                        "first": i === 0,
                        "last": i === (entries.length - 1),
                    };

                    feedHtml += web.getHandleBarHtml("activityfeed_entry_home", vars);
                }
            }
            if (targetElement) targetElement.innerHTML = feedHtml;
        }, () =>
        {
            console.warn("failed to load activityfeed");
            if (targetElement) ele.hide(targetElement);
        });
    }

    getLatestProjectList()
    {
        api.get("latestProjects", (result) =>
        {
            let html = web.getHandleBarHtml("project_list_headline", {
                "link": "/patches",
                "title": "Latest Patches"
            });
            html += "<div class=\"row\">";
            result.length = 12;
            for (const i in result)
            {
                const project = result[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            html += "</div>";
            ele.byId("latest-projects").innerHTML = html;
        });
    }

    getTopProjectList()
    {
        api.get("fav/top", (result) =>
        {
            let i = 0;
            let topMonthHtml = web.getHandleBarHtml("project_list_headline", {
                "link": "/patches#topMonth",
                "title": "Top Of The Month"
            });
            topMonthHtml += "<div class=\"row\">";

            if (result.topFavs.length > 8) result.topFavs.length = 8;
            if (result.topFavs.length < 4) result.topFavs.length = Math.min(4, result.topFavs.length);

            for (i in result.topFavs)
            {
                const project = result.topFavs[i].proj;
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                topMonthHtml += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            topMonthHtml += "</div>";
            document.getElementById("top-of-the-month").innerHTML = topMonthHtml;

            let allTimeHtml = web.getHandleBarHtml("project_list_headline", {
                "link": "/patches?or=favs#ppub",
                "title": "Top Patches (Six Months)"
            });
            allTimeHtml += "<div class=\"row\">";
            for (i in result.allTimeTop)
            {
                const project = result.allTimeTop[i].proj;
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                allTimeHtml += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            allTimeHtml += "</div>";
            document.getElementById("alltimetop").innerHTML = allTimeHtml;

            const featureFeed = document.getElementById("featured");
            if (featureFeed)
            {
                let project = result.featured;
                let template = "project_featured";
                let projectInfo = "";
                if (result.madeWithCables && result.featured)
                {
                    if ((Math.random() >= 0.5) ? 1 : 0)
                    {
                        project = result.featured;
                        projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                    }
                    else
                    {
                        project = result.madeWithCables;
                        template = "project_made_with_cables";
                    }
                }
                else if (result.featured)
                {
                    project = result.featured;
                    projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": "published" });
                }
                else if (result.madeWithCables)
                {
                    project = result.madeWithCables;
                }
                web.setHandleBarHtml(template, { "project": project, "projectInfo": projectInfo }, featureFeed);
            }
        });
    }

    getRandomOps()
    {
        api.get("doc/ops/random", (result) =>
        {
            let html = web.getHandleBarHtml("project_list_headline", {
                "link": "/ops",
                "title": "Random Ops"
            });
            html += "<div class=\"row\">";

            for (const i in result.ops)
            {
                if (result.ops[i]) html += web.getHandleBarHtml("projectop", result.ops[i]);
            }
            html += "</div>";
            document.getElementById("random-ops").innerHTML = html;
        });
    }
}
